import { Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';
import { RoleNames, RoutePaths } from '../shared/api/types/enums';
import { RoleGuard } from '../shared/guards/role.guard';

// PIM
export const pimRoutes: Routes = [
  {
    path: RoutePaths.PimProductsAndClustersProduct,
    loadChildren: () =>
      import('src/app/pim/products/product-details/product-details.module').then((mod) => mod.ProductDetailsModule),
    data: { role: [RoleNames.product, RoleNames.backoffice] },
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: RoutePaths.PimProductsAndClustersCluster,
    loadChildren: () =>
      import('src/app/pim/products/cluster-details/cluster-details.module').then((mod) => mod.ClusterDetailsModule),
    data: { role: [RoleNames.product, RoleNames.backoffice] },
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: RoutePaths.PimProductsAndClusters,
    loadChildren: () => import('src/app/pim/products/products.module').then((mod) => mod.ProductsModule),
    data: { role: [RoleNames.product, RoleNames.backoffice] },
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: 'pim/categories/:id',
    loadChildren: () =>
      import('src/app/pim/categories/categories.module').then((mod) => mod.CategoriesModule),
    data: { role: [RoleNames.product, RoleNames.backoffice] },
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: RoutePaths.PimCategories,
    loadChildren: () =>
      import('src/app/pim/category-management/category-management.module').then(
        (mod) => mod.CategoryManagementModule
      ),
    data: { role: [RoleNames.product, RoleNames.backoffice] },
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: RoutePaths.PimClusterDefinition,
    loadChildren: () =>
      import('src/app/admin/cluster-definition/cluster-definition.module').then((mod) => mod.ClusterDefinitionModule),
    data: { role: [RoleNames.product, RoleNames.backoffice] },
    canActivate: [AuthGuard, RoleGuard]
  }
];
